import {BaseApi} from './base-api';
import Vue from 'vue';

export class SurveyApi extends BaseApi {
  static apiUri = 'surveys';

  /** @return {Promise<>} */
  static sendGuestMail (bookingId) {
    return Vue.http.post(this.apiUri + '/' + bookingId + '/send-mail');
  }

  /** @return {Promise<EntityHttpResponse<SurveyResultStatisticDto>>} */
  static getSurveyStatistic (filterData) {
    return Vue.http.get(this.apiUri + '/statistic', {params: filterData});
  }

  /** @return {Promise<PagedHttpResponse<SurveyQuestionDto>>} */
  static getAllQuestions () {
    return Vue.http.get(this.apiUri + '/questions');
  }

  /**
   * @param {SurveyQuestionsUpdateRequest} surveyQuestionsUpdateRequest
   * @return {Promise<HttpResponse>}
   * */
  static updateAllQuestions (surveyQuestionsUpdateRequest) {
    return Vue.http.patch(this.apiUri + '/questions', surveyQuestionsUpdateRequest);
  }

  /**
   * @return {Promise<PagedHttpResponse<SurveyResultWithQuestionsDto>>}
   * @param {number} bookingId
   * */
  static getSurveyResult (bookingId) {
    return Vue.http.get(this.apiUri + '/' + bookingId);
  }

  /**
   * @param {number} bookingId
   * @param {SurveyResultUpdateRequest} surveyResultUpdateRequest
   * @return {Promise<HttpResponse>}
   * */
  static updateSurveyResult (bookingId, surveyResultUpdateRequest) {
    return Vue.http.patch(this.apiUri + '/' + bookingId, surveyResultUpdateRequest);
  }

  /**
   * @return {Promise<PagedHttpResponse<SurveyQuestionDto>>}
   * @param {number} bookingId
   * @param {string} token
   * */
  static getQuestionsForBooking (bookingId, token) {
    return Vue.http.get(this.apiUri + '/for-booking/' + bookingId + '/' + token);
  }

  /**
   * @return {Promise<HttpResponse>}
   * @param {number} bookingId
   * @param {string} token
   * @param {SurveyAnswerRequest} surveyAnswerRequest
   * */
  static answerQuestionsForBooking (bookingId, token, surveyAnswerRequest) {
    return Vue.http.post(this.apiUri + '/for-booking/' + bookingId + '/' + token, surveyAnswerRequest);
  }
}
